{
  "journalAudit.action.program.technology_change_propagated": "Programme : changement technologique propagé aux projets héritiers"
}
